<template>
	<section :class="applicationClass">
		<section :class="controlClass">
			<section class="app__wrapper">
				<app-header/>
				<app-control/>
				<mobile-control/>
			</section>
		</section>
    <app-privacy/>
		<section :class="contentClass">
			<ask-question type="mobile"/>
			<app-article
				v-for="section in sections"
				:color="section.color"
				:title="section.title"
				:type="section.type"
				:subtype="section?.subtype"
			>
				<template v-if="section.menu && section.menu.length > 1" v-slot:menu>
					<ul>
						<li v-for="item in section.menu">
						<span
							:class="{
								'active': item.isActive
							}"
							v-if="item.view"
							v-text="item.title"
							@click.prevent="setMenuActive({
								type: section.type,
								item: item
							})"
						/>
							<a
								v-if="item.href"
								v-text="item.title"
								:href="item.href"
								target="_blank"
							/>
						</li>
					</ul>
				</template>
			</app-article>
		</section>
		<router-view/>
		<popup v-if="isPopupOpened" />
	</section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppHeader from './components/AppHeader'
import AppControl from './components/AppControl'
import AppArticle from './components/AppArticle'
import MobileControl from './components/MobileControl'
import AskQuestion from './components/Ask'
import Popup from './components/Popup'
import AppPrivacy from "./components/AppPrivacy.vue";

export default {
	components: {
    AppPrivacy,
		AppArticle,
		AppControl,
		AppHeader,
		MobileControl,
		AskQuestion,
		Popup
	},
	computed:   {
		...mapGetters([
			'currentArticle',
			'sections',
			'isPopupOpened',
			'filteredMobileSections'
		]),
		applicationClass() {
			let classNames = [ 'app' ];
			let status     = this.currentArticle === 'home' ? 'home' : 'page';

			classNames.push(`app--${ status }`);

			return classNames.join(' ');
		},
		controlClass() {
			let classNames = [ 'app__control' ];
			let status     = this.currentArticle === 'home' ? 'active' : 'hidden';

			classNames.push(`app__control--${ status }`);

			return classNames.join(' ');
		},
		contentClass() {
			let classNames = [ 'app__content' ];
			let status     = this.currentArticle === 'home' ? 'hidden' : 'active';

			classNames.push(`app__content--${ status }`);

			return classNames.join(' ');
		}
	},
	methods:    {
		...mapActions([
			'setMenuActive',
      'showPopup'
		])
	}
}
</script>

<style lang="scss">
@import "assets/scss";

.app {
	position: relative;
	max-width: 1440px;
	margin: 0 auto;
  display: flex;
  flex-direction: column;

	&:before {
		content: '';
		position: fixed;
		z-index: 1;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: url(./assets/images/background.jpg);
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
    transition: background-position .6s ease;

		@media screen and ($media-mobile) {
			bottom: 45%;
      width: 300%;
      height: 100vw;
		}
	}

	&--home {
		&:before {
      background-position: 0 0;
		}
	}
  &--page {
    &:before {
      background-position: 50% 0;

      @media screen and ($media-mobile) {
        background-position: 0 50%;
      }
    }
  }

	&__control {
		position: relative;
		overflow: hidden;
		z-index: 2;

		&--active {
			max-height: 3000px;
			transition: max-height .5s ease 0s;
		}

		&--hidden {
			max-height: 32px;
			transition: max-height .5s ease 0s;

			@media screen and ($media-mobile) {
				max-height: 3000px;
			}
		}
	}

	&__content {
		position: relative;
		overflow: hidden;
		z-index: 2;

		&--active {
			opacity: 1;
			transform: translateY(0);
			transition: opacity .5s ease .25s;

			@media screen and ($media-mobile) {
				.article--privacy,
				.article--rules {
					display: none;
				}

			}
		}

		&--hidden {
			opacity: 0;
			transform: translateY(20%);
			transition: opacity .5s ease 0s;

			@media screen and ($media-mobile) {
				opacity: 1;
				transform: translateY(0);

				.article--privacy, 
				.article--rules {
					display: none;
				}
			}
		}
	}

  &__wrapper {
    transition: transform .5s ease;
    will-change: transform;

    .app__control--active & {
      transform: translateY(0);
    }

    .app__control--hidden & {
      transform: translateY(-100%);

      @media screen and ($media-mobile) {
        transform: translateY(0);
      }
    }
  }

}

.no-scroll {
	overflow: hidden;
}
</style>